export const stylesGW = {
  GrainTrackerLayoutForm: {
    layoutGraintrackerContainerBox: {
      width: "100%",
      maxWidth: 360,
      bgcolor: "#fff",
      overflow: "auto",
    },
    list: {
      width: "100%",
    },
    loadingButton: {
      textTransform: "none",
      width: "100%",
    },
  },

  principalInformation: {
    FormControl: {
      marginTop: "32px",
    },
    TextField: {
      marginTop: "24px",
    },
    FormControlSpecieContainer: {
      marginTop: "32px",
      marginRight: "10%",
      width: "40%",
      display: "flex",
    },
    AvailableCapacityTextField: {
      marginTop: "24px",
      width: "50%",
    },
  },

  FormCurrentCharacteristics: {
    TextField: {
      width: "80%",
      marginLeft: "12px",
    },
    inputProps: {
      fontSize: 13,
    },
    iconButton: {
      height: "30px",
    },
  },

  RenderQualityCriteriaInputsToCreate: {
    FormControlContainer: {
      width: "30%",
      display: "flex",
    },
    FormControlContainerTextField: {
      m: 1,
      width: "15%",
    },

    Autocomplete: {
      width: "40vw",
      maxWidth: "calc(100% - 20px)",
      marginBottom: "24px",
      marginLeft: "24px",
      marginTop: "24px",
    },
    AutocompleteTags: {
      display: "flex",
      flexWrap: "wrap",
      gap: 0.5,
    },
  },

  CreateQualityCriteriaInputs: {
    formCriteriaGTFormControl: {
      width: "30%",
      display: "flex",
    },
  },

  GrainTrackerMenuButtons: {
    buttons: {
      textTransform: "none",
    },
  },

  ShowsMessagesSuccess: {
    anchorOrigin: {
      vertical: "top",
      horizontal: "right",
    },
    alert: {
      width: "100%",
    },
    alertSucces: {
      width: "100%",
      marginTop: "5rem",
    },

    alertSucces2: {
      width: "100%",
      marginTop: "10rem",
    },
  },
};
